import React from 'react';
import { Observer } from '@poa/state';

export function ProfileModalLeftCorner({ state, requestGalleryClose }) {
  return (
    <Observer>
      {() => {
        return (
          <div className="popup__left-corner">
            <button
              className="popup__btn popup__btn_back js-subpopup-back"
              onClick={requestGalleryClose}
              style={{
                display: ['photo', 'video'].includes(state.galleryMode) ? 'inline-block' : 'none'
              }}
            >
              <svg className="icon icon-arraw-bottom" viewBox="0 0 9.5 4.93">
                <path d="M4.75 4.93L0 .75.66 0l4.09 3.6L8.84 0l.66.75-4.75 4.18z" />
              </svg>
              назад
            </button>
          </div>
        );
      }}
    </Observer>
  );
}
